import { c as _c } from "react/compiler-runtime";
import styles from './BlogMdxHeading.module.scss';

// 가이드 섹션 제목의 선행 번호("1." / "1.1." 등)를 라벨 스팬으로 분리한다.
// 번호는 MDX 제목 텍스트가 소스 (예: "## 1.1. 상세페이지 제작 – ...").
// 공백은 선택: BlogMdxH2 가 분리 렌더한 h2 의 textContent("1.1.제목")를
// BlogTOC 가 재파싱할 때는 라벨-제목 사이 공백이 없다.
export const SECTION_LABEL_RE = /^(\d+(?:\.\d+)*\.)\s*([\s\S]+)$/;
type BlogMdxH2Props = React.ComponentProps<'h2'>;
export function BlogMdxH2(t0) {
  const $ = _c(14);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  if (typeof children === "string") {
    let t1;
    if ($[3] !== children) {
      t1 = children.match(SECTION_LABEL_RE);
      $[3] = children;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    const match = t1;
    if (match) {
      let t2;
      if ($[5] !== match[1]) {
        t2 = <span className={styles.label}>{match[1]}</span>;
        $[5] = match[1];
        $[6] = t2;
      } else {
        t2 = $[6];
      }
      let t3;
      if ($[7] !== match[2] || $[8] !== props || $[9] !== t2) {
        t3 = <h2 {...props}>{t2}{match[2]}</h2>;
        $[7] = match[2];
        $[8] = props;
        $[9] = t2;
        $[10] = t3;
      } else {
        t3 = $[10];
      }
      return t3;
    }
  }
  let t1;
  if ($[11] !== children || $[12] !== props) {
    t1 = <h2 {...props}>{children}</h2>;
    $[11] = children;
    $[12] = props;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
}